/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { FormFeedback, Row, Col, FormGroup, Form, Label, Input, Collapse, Button } from 'reactstrap';
import { HelpTextHover } from './Tooltip'
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { MaxCatchUpContribution } from '../constants/Global'
import 'bootstrap/dist/css/bootstrap.min.css';
import { PlusLg, DashLg, ChevronDoubleUp, ChevronDoubleDown } from 'react-bootstrap-icons';
import ReactSlider from 'react-slider';
import { formatWithCommas, getTooltipValue, getInputValue, getInputName } from '../utils/Format';
import { formatToNumber } from '../utils/Format'; 

const DebugSlider = ({ label, value, ...rest }) => {
    const isNum = typeof value === 'number' && Number.isFinite(value);
    if (!isNum) {
        console.warn(`[DebugSlider] ${label} received non-number value:`, value, `(type: ${typeof value})`);
    }
    return <ReactSlider value={value} {...rest} />;
};

export class Inputs extends Component {
    constructor(props) {

        super(props);
        this.toggleSection = this.toggleSection.bind(this);
        this.preStateChangeValidate = this.preStateChangeValidate.bind(this);
        this.state = {
            ShowSectionPersonal: false,
            ShowSection401: true,
            ShowSectionESOP: true,
            currentAgeInvalid: false,
            retirementAgeInvalid: false,
            currentCompInvalid: false,
            compRateInvalid: false,
            catchUpAmountInvalid: false,
            current401Invalid: false,
            deferralPercentageInvalid: false,
            est401ReturnInvalid: false,
            beginningSharesHeldInvalid: false,
            assumedPercentageIncreaseSharesInvalid: false,
            assumedPercentageIncreaseDividendsInvalid: false,
            openingCashBalanceInvalid: false,
            assumedPercentageIncreaseCashInvalid: false,
            editingField: null,

            currentCompInput: formatWithCommas(props.currentComp || 0),
            catchUpAmountInput: formatWithCommas(props.catchUpAmount || 0),
            current401Input: formatWithCommas(props.current401 || 0),
            openingCashBalanceInput: formatWithCommas(props.openingCashBalance || 0),
        };
    }

    handleFocus = (fieldKey) => {
        this.setState({ editingField: fieldKey });
    };

    handleBlur = (stateKey) => {
        // finish edit -> pretty print and clear editing flag
        this.setState(s => ({
            [stateKey]: formatWithCommas(s[stateKey]),
            editingField: null
        }));
    };

    toggleSection(sectionName) {
        let NameOfShowState = "ShowSection" + sectionName;
        this.setState({
            [NameOfShowState]: !this.state[NameOfShowState]
        });
    }

    componentDidUpdate(prevProps) {
        const changed = (k) => prevProps[k] !== this.props[k];

        if (changed('currentComp') && this.state.editingField !== 'currentCompInput') {
            this.setState({ currentCompInput: formatWithCommas(this.props.currentComp || 0) });
        }
        if (changed('catchUpAmount') && this.state.editingField !== 'catchUpAmountInput') {
            this.setState({ catchUpAmountInput: formatWithCommas(this.props.catchUpAmount || 0) });
        }
        if (changed('current401') && this.state.editingField !== 'current401Input') {
            this.setState({ current401Input: formatWithCommas(this.props.current401 || 0) });
        }
        if (changed('openingCashBalance') && this.state.editingField !== 'openingCashBalanceInput') {
            this.setState({ openingCashBalanceInput: formatWithCommas(this.props.openingCashBalance || 0) });
        }
    }

    // when the user types in a currency field
    handleCurrencyChange = (stateKey, parentKey, evt) => {
        const raw = evt.target.value;                 // keep what they typed
        this.setState({ [stateKey]: raw });

        // Try to parse to a number and push up immediately if valid (>= 0)
        const num = formatToNumber(raw);
        const isValid = raw !== '' && !Number.isNaN(num) && num >= 0;

        // update local invalid flag names follow your pattern: `${parentKey}Invalid`
        const invalidKey = `${parentKey}Invalid`;
        this.setState({ [invalidKey]: !isValid });

        // Only recompute when valid
        this.props.updateState(isValid ? num : raw, parentKey, isValid);
    };

    // when they leave the field, beautify the buffer with commas
    handleCurrencyBlur = (stateKey) => {
        this.setState((s) => ({ [stateKey]: formatWithCommas(s[stateKey]) }));
    };

    preStateChangeValidate(value, stateName) {
        if (stateName === "currentAge") {
            const num = Number(value);
            const ok = value !== '' && !Number.isNaN(num) && num >= 18 && num <= 99;
            this.setState({ currentAgeInvalid: !ok });
            this.props.updateState(ok ? num : value, "currentAge", ok);
        }

        if (stateName === "retirementAge") {
            const num = Number(value);
            const ok = value !== '' && !Number.isNaN(num) && num >= 18 && num <= 99;
            this.setState({ retirementAgeInvalid: !ok });
            this.props.updateState(ok ? num : value, "retirementAge", ok);
        }

        if (stateName === "currentComp") {
            if (value > 0 && value !== '') {
                this.setState({ currentCompInvalid: false });
                this.props.updateState(value, "currentComp", true);
            } else {
                this.setState({ currentCompInvalid: true });
                this.props.updateState(value, "currentComp", false);
            }
        }

        if (stateName === "compRate") {
            const num = Number(value);
            const ok = value !== '' && !Number.isNaN(num) && num >= 0;
            this.setState({ compRateInvalid: !ok });
            this.props.updateState(ok ? num : value, "compRate", ok);

        }

        if (stateName === "catchUpAmount") {
            if (value >= 0 && value !== '' && value <= MaxCatchUpContribution) {
                this.setState({ catchUpAmountInvalid: false });
                this.props.updateState(value, "catchUpAmount", true);
            } else {
                this.setState({ catchUpAmountInvalid: true });
                this.props.updateState(value, "catchUpAmount", false);
            }
        }

        //if (stateName === "current401") {
        //    if (value >= 0 && value !== '') {
        //        this.setState({ current401Invalid: false });
        //        this.props.updateState(value, "current401", true);
        //    } else {
        //        this.setState({ current401Invalid: true });
        //        this.props.updateState(value, "current401", false);
        //    }
        //}

        if (stateName === "deferralPercentage") {
            const num = Number(value);
            const ok = value !== '' && !Number.isNaN(num) && num >= 0;
            this.setState({ deferralPercentageInvalid: !ok });
            this.props.updateState(ok ? num : value, "deferralPercentage", ok);
        }

        if (stateName === "est401Return") {
            const num = Number(value);
            const ok = value !== '' && !Number.isNaN(num) && num >= 0;
            this.setState({ est401ReturnInvalid: !ok });
            this.props.updateState(ok ? num : value, "est401Return", ok);
        }

        if (stateName === "beginningSharesHeld") {
            const num = Number(value);
            const ok = value !== '' && !Number.isNaN(num) && num >= 0;
            this.setState({ beginningSharesHeldInvalid: !ok });
            this.props.updateState(ok ? num : value, "beginningSharesHeld", ok);
        }

        if (stateName === "assumedPercentageIncreaseShares") {
            const num = Number(value);
            const ok = value !== '' && !Number.isNaN(num) && num >= 0;
            this.setState({ assumedPercentageIncreaseSharesInvalid: !ok });
            this.props.updateState(ok ? num : value, "assumedPercentageIncreaseShares", ok);
        }

        if (stateName === "assumedPercentageIncreaseDividends") {
            const num = Number(value);
            const ok = value !== '' && !Number.isNaN(num) && num >= 0;
            this.setState({ assumedPercentageIncreaseDividendsInvalid: !ok });
            this.props.updateState(ok ? num : value, "assumedPercentageIncreaseDividends", ok);
        }

        //if (stateName === "openingCashBalance") {
        //    if (value >= 0 && value !== '') {
        //        this.setState({ openingCashBalanceInvalid: false });
        //        this.props.updateState(value, "openingCashBalance", true);
        //    } else {
        //        this.setState({ openingCashBalanceInvalid: true });
        //        this.props.updateState(value, "openingCashBalance", false);
        //    }
        //}

        if (stateName === "assumedPercentageIncreaseCash") {
            const num = Number(value);
            const ok = value !== '' && !Number.isNaN(num) && num >= 0;
            this.setState({ assumedPercentageIncreaseCashInvalid: !ok });
            this.props.updateState(ok ? num : value, "assumedPercentageIncreaseCash", ok);
        }
    }

    render() {
        let audienceType = this.props.audience;
        let helpTextData = this.props.helpTextData;

        let CurrentCompTooltipText = getTooltipValue(helpTextData, audienceType, 1);
        let CompRateTooltipText = getTooltipValue(helpTextData, audienceType, 6);
        let DeferralTooltipText = getTooltipValue(helpTextData, audienceType, 7);
        let CatchUpTooltipText = getTooltipValue(helpTextData, audienceType, 8);
        let Current401TooltipText = getTooltipValue(helpTextData, audienceType, 9);
        let ShareIncreaseTooltipText = getTooltipValue(helpTextData, audienceType, 14);
        let PercentIncreaseTooltipText = getTooltipValue(helpTextData, audienceType, 15);
        let CurrentESOPTooltipText = getTooltipValue(helpTextData, audienceType, 17);
        let EstESOPReturnTooltipText = getTooltipValue(helpTextData, audienceType, 18);
        let BeginningSharesTooltipText = getTooltipValue(helpTextData, audienceType, 12);
        let Est401ReturnTooltipText = getTooltipValue(helpTextData, audienceType, 10);

        let inputData = this.props.inputData;

        let CurrentAgeVisible = getInputValue(inputData, audienceType, 1);
        let RetirementAgeVisible = getInputValue(inputData, audienceType, 2);
        let CurrentCompensationVisible = getInputValue(inputData, audienceType, 3);
        let AnnualCompGrowthRateVisible = getInputValue(inputData, audienceType, 4);
        let DeferralVisible = getInputValue(inputData, audienceType, 5);
        let AnnualCatchUpVisible = getInputValue(inputData, audienceType, 6);
        let Current401BalanceVisible = getInputValue(inputData, audienceType, 7);
        let Annual401ReturnVisible = getInputValue(inputData, audienceType, 8);
        let BeginningSharesESOPVisible = getInputValue(inputData, audienceType, 9);
        let AnnualSharePriceIncreaseVisible = getInputValue(inputData, audienceType, 10);
        let AnnualDividendIncreaseVisible = getInputValue(inputData, audienceType, 11);
        let CurrentESOPCashBalanceVisible = getInputValue(inputData, audienceType, 12);
        let ESOPCashReturnRateVisible = getInputValue(inputData, audienceType, 13);

        let CurrentAgeName = getInputName(inputData, audienceType, 1);
        let RetirementAgeName = getInputName(inputData, audienceType, 2);
        let CurrentCompensationName = getInputName(inputData, audienceType, 3);
        let AnnualCompGrowthRateName = getInputName(inputData, audienceType, 4);
        let DeferralName = getInputName(inputData, audienceType, 5);
        let AnnualCatchUpName = getInputName(inputData, audienceType, 6);
        let Current401BalanceName = getInputName(inputData, audienceType, 7);
        let Annual401ReturnName = getInputName(inputData, audienceType, 8);
        let BeginningSharesESOPName = getInputName(inputData, audienceType, 9);
        let AnnualSharePriceIncreaseName = getInputName(inputData, audienceType, 10);
        let AnnualDividendIncreaseName = getInputName(inputData, audienceType, 11);
        let CurrentESOPCashBalanceName = getInputName(inputData, audienceType, 12);
        let ESOPCashReturnRateName = getInputName(inputData, audienceType, 13);

        // TEMP DIAGNOSTIC: log any slider getting a non-number value
        //const sliderInputs = {
        //    currentAge: this.props.currentAge,
        //    retirementAge: this.props.retirementAge,
        //    compRate: this.props.compRate,
        //    deferralPercentage: this.props.deferralPercentage,
        //    catchUpAmount: this.props.catchUpAmount,
        //    est401Return: this.props.est401Return,
        //    assumedPercentageIncreaseShares: this.props.assumedPercentageIncreaseShares,
        //    assumedPercentageIncreaseDividends: this.props.assumedPercentageIncreaseDividends,
        //    assumedPercentageIncreaseCash: this.props.assumedPercentageIncreaseCash,
        //};

        //Object.entries(sliderInputs).forEach(([name, val]) => {
        //    const isNum = typeof val === 'number' && Number.isFinite(val);
        //    if (!isNum) {
        //        // This will point to the specific slider/key and show the actual value/type
        //        console.warn(`[Slider value issue] ${name} ->`, val, `(type: ${typeof val})`);
        //    }
        //});


        return (
            <>
                <Form className="calcForm bg-light">
                    <div className="sectionHeader"><span>Personal Information </span><Button onClick={() => this.toggleSection("Personal")} className='btn-toggle'>{this.state.ShowSectionPersonal === false ? <ChevronDoubleDown className="toggleImage" /> : <ChevronDoubleUp className="toggleImage" />}</Button></div>
                    <Collapse isOpen={this.state.ShowSectionPersonal}>
                        <FormGroup>
                            {CurrentAgeVisible && 
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputCurrentAge">
                                            {CurrentAgeName}
                                        </Label>
                                        <Input
                                            id="inputCurrentAge"
                                            type="number"
                                            value={this.props.currentAge}
                                            invalid={this.state.currentAgeInvalid}
                                            onChange={(evt) => this.preStateChangeValidate(evt.target.value, "currentAge")} />
                                        <FormFeedback>Please enter a valid number.</FormFeedback>
                                    </Col>
                                    <Col>
                                        <ReactSlider
                                            onChange={(value) => this.props.updateState(value, "currentAge", true)}
                                            value={this.props.currentAge || 0}
                                            renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                            max={99}
                                            min={18}
                                        />
                                    </Col>
                                </Row>
                            }
                            {RetirementAgeVisible && 
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputRetirementAge">
                                            {RetirementAgeName}
                                        </Label>
                                        <Input
                                            id="inputRetirementAge"
                                            type="number"
                                            value={this.props.retirementAge}
                                            invalid={this.state.retirementAgeInvalid}
                                            onChange={(evt) => this.preStateChangeValidate(evt.target.value, "retirementAge")} />
                                        <FormFeedback>Please enter a valid number.</FormFeedback>
                                    </Col>
                                    <Col>
                                        <DebugSlider
                                            onChange={(value) => this.props.updateState(value, "retirementAge", true)}
                                            value={this.props.retirementAge || 0}
                                            renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                            max={99}
                                            min={18}
                                        />
                                    </Col>
                                </Row>
                            }
                            {CurrentCompensationVisible &&
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputTotalComp">
                                            {CurrentCompensationName}
                                        </Label>
                                        <a data-tooltip-id="CurrentComp"><HelpTextHover /></a>
                                        <ReactTooltip id="CurrentComp" aria-haspopup="true">{CurrentCompTooltipText}</ReactTooltip>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text dollarPrepend">$</div>
                                            </div>
                                            <Input
                                                id="inputTotalComp"
                                                type="text"
                                                className="dollarPrependInput"
                                                value={this.state.currentCompInput}
                                                invalid={this.state.currentCompInvalid}
                                                onFocus={() => this.handleFocus('currentCompInput')}
                                                onBlur={() => this.handleBlur('currentCompInput')}
                                                onChange={(e) => this.handleCurrencyChange('currentCompInput', 'currentComp', e)}
                                            />
                                            <FormFeedback>Please enter a valid number.</FormFeedback>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="upDownWrapper">
                                            <div className="arrowWrapper">
                                                <a title="Increase by $1,000" onClick={() => this.props.valueUpDown("up", "currentComp", 1000.00)}>
                                                    <PlusLg height={35} width={60} color="#ddd" />
                                                </a>
                                            </div>
                                            <div className="arrowWrapper">
                                                <a title="Decrease by $1,000" onClick={() => this.props.valueUpDown("down", "currentComp", 1000.00)}>
                                                    <DashLg height={35} width={60} color="#ddd" />
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            }
                            {AnnualCompGrowthRateVisible && 
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputCompRate">
                                            {AnnualCompGrowthRateName}
                                        </Label>
                                        <a data-tooltip-id="CompRate"><HelpTextHover /></a>
                                        <ReactTooltip id="CompRate" aria-haspopup="true">{CompRateTooltipText}</ReactTooltip>
                                        <div className="input-group">
                                            <Input step={1} className="percentAppendInput" type="number"
                                                id="inputCompRate"
                                                value={this.props.compRate}
                                                invalid={this.state.compRateInvalid}
                                                onChange={(evt) => this.preStateChangeValidate(evt.target.value, "compRate")} />
                                            <div className="input-group-append">
                                                <span className="input-group-text percentAppend">%</span>
                                            </div>
                                            <FormFeedback>Please enter a valid number.</FormFeedback>
                                        </div>
                                    </Col>
                                    <Col>
                                        <DebugSlider
                                            onChange={(value) => this.props.updateState(value, "compRate", true)}
                                            value={this.props.compRate || 0}
                                            renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                            step={0.5}
                                            max={15}
                                            min={0}
                                        />
                                    </Col>
                                </Row>
                            }
                        </FormGroup>
                    </Collapse>
                </Form>
                <Form className="calcForm bg-light">
                    <div className="sectionHeader"><span>401(k) Information </span><Button onClick={() => this.toggleSection("401")} className='btn-toggle' >{this.state.ShowSection401 === false ? <ChevronDoubleDown className="toggleImage" /> : <ChevronDoubleUp className="toggleImage" />}</Button></div>
                    <Collapse isOpen={this.state.ShowSection401}>
                        <FormGroup>
                            {DeferralVisible &&
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputDeferral">
                                            {DeferralName}
                                        </Label>
                                        <a data-tooltip-id="Deferral"><HelpTextHover /></a>
                                        <ReactTooltip id="Deferral" aria-haspopup="true">{DeferralTooltipText}</ReactTooltip>
                                        <div className="input-group">
                                            <Input step={1} type="number" className="percentAppendInput"
                                                id="inputDeferral"
                                                value={this.props.deferralPercentage}
                                                invalid={this.state.deferralPercentageInvalid}
                                                onChange={(evt) => this.preStateChangeValidate(evt.target.value, "deferralPercentage")} />
                                            <div className="input-group-append">
                                                <span className="input-group-text percentAppend">%</span>
                                            </div>
                                            <FormFeedback>Please enter a valid number.</FormFeedback>
                                        </div>
                                    </Col>
                                    <Col>
                                        <DebugSlider
                                            onChange={(value) => this.props.updateState(value, "deferralPercentage", true)}
                                            value={this.props.deferralPercentage || 0}
                                            renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                            step={0.5}
                                            max={50}
                                            min={0}
                                        />
                                    </Col>
                                </Row>
                            }
                            {AnnualCatchUpVisible &&
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputCatchUp">
                                            {AnnualCatchUpName}
                                        </Label>
                                        <a data-tooltip-id="CatchUp"><HelpTextHover /></a>
                                        <ReactTooltip id="CatchUp" aria-haspopup="true">{CatchUpTooltipText}</ReactTooltip>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text dollarPrepend">$</div>
                                            </div>
                                            <Input type="text"
                                                id="inputCatchUp"
                                                className="dollarPrependInput"
                                                value={this.state.catchUpAmountInput}
                                                invalid={this.state.catchUpAmountInvalid}
                                                onChange={(e) => this.handleCurrencyChange('catchUpAmountInput', 'catchUpAmount', e)}
                                                onFocus={() => this.handleFocus('catchUpAmountInput')}
                                                onBlur={() => this.handleBlur('catchUpAmountInput')} />
                                            <FormFeedback>Please enter a valid number.</FormFeedback>
                                        </div>
                                    </Col>
                                    <Col>
                                        <DebugSlider
                                            onChange={(value) => this.props.updateState(value, "catchUpAmount", true)}
                                            value={this.props.catchUpAmount || 0}
                                            renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                            max={MaxCatchUpContribution}//{this.props.MaxCatchUpContribution}
                                            min={0}
                                        />
                                    </Col>
                                </Row>
                            }
                            {Current401BalanceVisible &&
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputCurrent401">
                                            {Current401BalanceName}
                                        </Label>
                                        <a data-tooltip-id="Current401"><HelpTextHover /></a>
                                        <ReactTooltip id="Current401" aria-haspopup="true">{Current401TooltipText}</ReactTooltip>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text dollarPrepend">$</div>
                                            </div>
                                            <Input type="text" className="dollarPrependInput"
                                                id="inputCurrent401"
                                                onFocus={() => this.handleFocus('current401Input')}
                                                onBlur={() => this.handleBlur('current401Input')}
                                                value={this.state.current401Input}
                                                invalid={this.state.current401Invalid}
                                                onChange={(e) => this.handleCurrencyChange('current401Input', 'current401', e)} />
                                            <FormFeedback>Please enter a valid number.</FormFeedback>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="upDownWrapper">
                                            <div className="arrowWrapper">
                                                <a title="Increase by $1,000" onClick={() => this.props.valueUpDown("up", "current401", 1000.00)}>
                                                    <PlusLg height={35} width={60} color="#ddd" />
                                                </a>
                                            </div>
                                            <div className="arrowWrapper">
                                                <a title="Decrease by $1,000" onClick={() => this.props.valueUpDown("down", "current401", 1000.00)}>
                                                    <DashLg height={35} width={60} color="#ddd" />
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            }
                            {Annual401ReturnVisible &&
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputEst401Return">
                                            {Annual401ReturnName}
                                        </Label>
                                        <a data-tooltip-id="Est401Return"><HelpTextHover /></a>
                                        <ReactTooltip id="Est401Return" aria-haspopup="true">{Est401ReturnTooltipText}</ReactTooltip>
                                        <div className="input-group">
                                            <Input type="number" className="percentAppendInput" value={this.props.est401Return}
                                                id="inputEst401Return"
                                                invalid={this.state.est401ReturnInvalid}
                                                onChange={(evt) => this.preStateChangeValidate(evt.target.value, "est401Return")} />
                                            <div className="input-group-append">
                                                <span className="input-group-text percentAppend">%</span>
                                            </div>
                                            <FormFeedback>Please enter a valid number.</FormFeedback>
                                        </div>
                                    </Col>
                                    <Col>
                                        <DebugSlider
                                            onChange={(value) => this.props.updateState(value, "est401Return", true)}
                                            value={this.props.est401Return || 0}
                                            renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                            step={0.5}
                                            max={15}
                                            min={0}
                                        />
                                    </Col>
                                </Row>
                            }
                        </FormGroup>
                    </Collapse>
                </Form>
                <Form className="calcForm bg-light">
                    <div className="sectionHeader"><span>ESOP Information </span><Button onClick={() => this.toggleSection("ESOP")} className='btn-toggle'>{this.state.ShowSectionESOP === false ? <ChevronDoubleDown className="toggleImage" /> : <ChevronDoubleUp className="toggleImage" />}</Button></div>
                    <Collapse isOpen={this.state.ShowSectionESOP}>
                        <FormGroup>
                            {BeginningSharesESOPVisible &&
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputBeginningShares">
                                            {BeginningSharesESOPName}
                                        </Label>
                                        <a data-tooltip-id="BeginningShares"><HelpTextHover /></a>
                                        <ReactTooltip id="BeginningShares" aria-haspopup="true">{BeginningSharesTooltipText}</ReactTooltip>
                                        <Input type="number" value={this.props.beginningSharesHeld}
                                            id="inputBeginningShares"
                                            invalid={this.state.beginningSharesHeldInvalid}
                                            onChange={(evt) => this.preStateChangeValidate(evt.target.value, "beginningSharesHeld")} />
                                        <FormFeedback>Please enter a valid number.</FormFeedback>
                                    </Col>
                                    <Col>
                                        <div className="upDownWrapper">
                                            <div className="arrowWrapper">
                                                <a title="Increase by 1" onClick={() => this.props.valueUpDown("up", "beginningSharesHeld", 1)}>
                                                    <PlusLg height={35} width={60} color="#ddd" />
                                                </a>
                                            </div>
                                            <div className="arrowWrapper">
                                                <a title="Decrease by 1" onClick={() => this.props.valueUpDown("down", "beginningSharesHeld", 1)}>
                                                    <DashLg height={35} width={60} color="#ddd" />
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            }
                            {AnnualSharePriceIncreaseVisible &&
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputShareIncrease">
                                            {AnnualSharePriceIncreaseName}
                                        </Label>
                                        <a data-tooltip-id="ShareIncrease"><HelpTextHover /></a>
                                        <ReactTooltip id="ShareIncrease" aria-haspopup="true">{ShareIncreaseTooltipText}</ReactTooltip>
                                        <div className="input-group">
                                            <Input type="number" className="percentAppendInput" value={this.props.assumedPercentageIncreaseShares}
                                                id="inputShareIncrease"
                                                invalid={this.state.assumedPercentageIncreaseSharesInvalid}
                                                onChange={(evt) => this.preStateChangeValidate(evt.target.value, "assumedPercentageIncreaseShares")} />
                                            <div className="input-group-append">
                                                <span className="input-group-text percentAppend">%</span>
                                            </div>
                                            <FormFeedback>Please enter a valid number.</FormFeedback>
                                        </div>
                                    </Col>
                                    <Col>
                                        <DebugSlider
                                            onChange={(value) => this.props.updateState(value, "assumedPercentageIncreaseShares", true)}
                                            value={this.props.assumedPercentageIncreaseShares || 0}
                                            renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                            step={0.5}
                                            max={15}
                                            min={0}
                                        />
                                    </Col>
                                </Row>
                            }
                            {AnnualDividendIncreaseVisible &&
                                <Row>
                                <Col xs="8">
                                    <Label for="inputPercentIncrease">
                                            {AnnualDividendIncreaseName}
                                    </Label>
                                        <a data-tooltip-id="PercentIncrease"><HelpTextHover /></a>
                                    <ReactTooltip id="PercentIncrease" aria-haspopup="true">{PercentIncreaseTooltipText}</ReactTooltip>
                                    <div className="input-group">
                                            <Input type="number" className="percentAppendInput" value={this.props.assumedPercentageIncreaseDividends}
                                                id="inputPercentIncrease"
                                            invalid={this.state.assumedPercentageIncreaseDividendsInvalid}
                                            onChange={(evt) => this.preStateChangeValidate(evt.target.value, "assumedPercentageIncreaseDividends")} />
                                        <div className="input-group-append">
                                            <span className="input-group-text percentAppend">%</span>
                                        </div>
                                        <FormFeedback>Please enter a valid number.</FormFeedback>
                                    </div>
                                </Col>
                                <Col>
                                        <DebugSlider
                                        onChange={(value) => this.props.updateState(value, "assumedPercentageIncreaseDividends", true)}
                                            value={this.props.assumedPercentageIncreaseDividends || 0}
                                        renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                        step={0.5}
                                        max={15}
                                        min={0}
                                    />
                                </Col>
                                </Row>
                            }
                            {CurrentESOPCashBalanceVisible &&
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputCurrentESOP">
                                            {CurrentESOPCashBalanceName}
                                        </Label>
                                        <a data-tooltip-id="CurrentESOP"><HelpTextHover /></a>
                                        <ReactTooltip id="CurrentESOP" aria-haspopup="true">{CurrentESOPTooltipText}</ReactTooltip>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text dollarPrepend">$</div>
                                            </div>
                                            <Input type="text" className="dollarPrependInput"
                                                id="inputCurrentESOP"
                                                onFocus={() => this.handleFocus('openingCashBalanceInput')}
                                                onBlur={() => this.handleBlur('openingCashBalanceInput')}
                                                value={this.state.openingCashBalanceInput}
                                                invalid={this.state.openingCashBalanceInvalid}
                                                onChange={(e) => this.handleCurrencyChange('openingCashBalanceInput', 'openingCashBalance', e)} />
                                            <FormFeedback>Please enter a valid number.</FormFeedback>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="upDownWrapper">
                                            <div className="arrowWrapper">
                                                <a title="Increase by $1,000" onClick={() => this.props.valueUpDown("up", "openingCashBalance", 1000.00)}>
                                                    <PlusLg height={35} width={60} color="#ddd" />
                                                </a>
                                            </div>
                                            <div className="arrowWrapper">
                                                <a title="Decrease by $1,000" onClick={() => this.props.valueUpDown("down", "openingCashBalance", 1000.00)}>
                                                    <DashLg height={35} width={60} color="#ddd" />
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            }
                            {ESOPCashReturnRateVisible && 
                                <Row>
                                    <Col xs="8">
                                        <Label for="inputEstESOPReturn">
                                            {ESOPCashReturnRateName}
                                        </Label>
                                        <a data-tooltip-id="EstESOPReturn"><HelpTextHover /></a>
                                        <ReactTooltip id="EstESOPReturn" aria-haspopup="true">{EstESOPReturnTooltipText}</ReactTooltip>
                                        <div className="input-group">
                                            <Input type="number" className="percentAppendInput" value={this.props.assumedPercentageIncreaseCash}
                                                id="inputEstESOPReturn"
                                                invalid={this.state.assumedPercentageIncreaseCashInvalid}
                                                onChange={(evt) => this.preStateChangeValidate(evt.target.value, "assumedPercentageIncreaseCash")} />
                                            <div className="input-group-append">
                                                <span className="input-group-text percentAppend">%</span>
                                            </div>
                                            <FormFeedback>Please enter a valid number.</FormFeedback>
                                        </div>
                                    </Col>
                                    <Col>
                                        <DebugSlider
                                            onChange={(value) => this.props.updateState(value, "assumedPercentageIncreaseCash", true)}
                                            value={this.props.assumedPercentageIncreaseCash || 0}
                                            renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                            step={0.5}
                                            max={15}
                                            min={0}
                                        />
                                    </Col>
                                </Row>
                            }
                        </FormGroup>
                    </Collapse>
                </Form>
            </>
        );
    }
}
